import {Country} from "../defs/country";
import {CountryGroup} from "../defs/group";

export const Seychelles: Country = {
    identifier: "Seychelles",
    name: "Seychelles",
    countryCode: "SC",
    group: CountryGroup.AFRICA,
    isUNMember: true,
    flag: "🇸🇨",
    svgPath: "m 630.76775,476.0194 0.008,0.259 -0.135,-0.087 -0.038,-0.167 -0.18,-0.125 -0.094,-0.114 0.203,-0.141 z",
}
